module.exports = __webpack_public_path__ + "img/icon8.5d3851a3.svg";